/** The editor's own copy: the seven actions and the dialog that asks for a link. */

/**
 * The toolbar (edit mode only): the seven actions that were asked for, and nothing markdown can express that
 * a prompt has no use for.
 */
export const MARK_HINT = {
  bold: "Bold",
  italic: "Italic",
  underline: "Underline",
};

/**
 * The heading menu (BA's request). A menu rather than six buttons: the bar has seven icons already, and a
 * heading is a choice among seven states — including "not a heading", which buttons have nowhere to put.
 */
export const HEADING_HINT = "Heading level";

export const HEADING_LABEL = (level: number) => `H${level}`;

/** What a paragraph reads as in a menu of headings, and the way back out of one. */
export const HEADING_NORMAL_LABEL = "Normal text";

export const UNORDERED_LIST_HINT = "Bulleted list";

export const ORDERED_LIST_HINT = "Numbered list";

export const INSERT_LINK_HINT = "Insert link";

export const CLEAR_FORMATTING_HINT = "Clear formatting";

export const LINK_MODAL_TITLE = "Insert link";

export const LINK_MODAL_OK_TEXT = "Insert";

export const LINK_URL_PLACEHOLDER = "https://";

/**
 * Said as the paste lands, naming what came in that the editor cannot show.
 *
 * 🔴 AT THE MOMENT OF THE PASTE, not only in the footer. The footer's refusal is there too, but an operator
 * who has just pasted three pages does not read the footer — and the fix is to go back to where the text came
 * from, which is easiest while they are still in that document.
 */
export const UNSUPPORTED_PASTE_NOTICE = (unsupported: string[]) =>
  `Pasted content includes ${unsupported.join(
    " and "
  )}, which the editor cannot show. Saving is disabled until it is removed.`;
